import { useState } from 'react';
import { Link } from 'react-router-dom';
import { creatorPath } from '../creator-connections/creatorConnectionsModel';
import { groupTripMemberFacingLabel } from '../member-identity/memberIdentityPresentation';

/**
 * Public GroupTrip host identity (AUTH54 GT54-2).
 * Linkable only when backend marks profileAvailable; otherwise bounded "主辦人" without raw ID.
 */
export default function GroupTripHostIdentity({
  host,
  className = 'group-trip-host-identity',
  testId = 'group-trip-host-identity',
}) {
  const [broken, setBroken] = useState(false);
  const summary = host && typeof host === 'object' ? host : null;
  const memberId = summary?.memberId ?? null;
  const profileAvailable = Boolean(summary?.profileAvailable) && memberId != null;
  const displayName = summary?.displayName
    || groupTripMemberFacingLabel({ role: 'host' });
  const to = profileAvailable ? creatorPath(memberId) : null;
  const initial = String(displayName || '主').slice(0, 1).toUpperCase();
  const avatar = summary?.avatarUrl && !broken
    ? <img className="group-trip-host-identity__avatar" src={summary.avatarUrl} alt="" onError={() => setBroken(true)} />
    : (
      <span className="group-trip-host-identity__avatar group-trip-host-identity__avatar--fallback" aria-hidden="true">
        {initial}
      </span>
    );

  const body = (
    <>
      {avatar}
      <span className="group-trip-host-identity__name">{displayName}</span>
    </>
  );

  if (to) {
    return (
      <Link
        className={className}
        to={to}
        data-testid={testId}
        data-profile-available="true"
      >
        {body}
      </Link>
    );
  }

  return (
    <span
      className={`${className} ${className}--static`}
      data-testid={testId}
      data-profile-available="false"
    >
      {body}
    </span>
  );
}
